import { SciChartSurface } from "scichart";
import { libraryVersion } from "scichart/Core/BuildStamp";

// Ścieżka musi być identyczna z tą, do której kopiuje build/scichart-wasm.js.
const basePath = `/static/scichart/${libraryVersion}/`;

export const dataUrl = `${basePath}scichart2d.data`;
export const wasmUrl = `${basePath}scichart2d.wasm`;

export function configureSciChartWasm () {
  SciChartSurface.configure({ dataUrl, wasmUrl });
}

// SciChart łapie KAŻDY błąd ładowania wasm jednym catch-em (createMaster.js) i
// zawsze wypisuje ten sam komunikat o niezgodnych wersjach. Dlatego 404,
// przekierowanie na index.html przez fallback SPA, zły MIME i realny rozjazd
// wersji wyglądają w konsoli identycznie. Ta funkcja sprawdza, co serwer
// naprawdę zwraca, i nazywa przyczynę.
export function diagnoseSciChartWasm () {
  return Promise.all([check(wasmUrl, WASM_MAGIC), check(dataUrl, null)])
    .then(function (problems) {
      const found = problems.filter(Boolean)

      if (found.length) {
        console.error(
          '[SciChart] Pliki wasm są nieosiągalne lub uszkodzone – wykresy nie ' +
          'wystartują, a SciChart pokaże mylący komunikat o niezgodnych ' +
          'wersjach.\n' + found.join('\n') +
          '\nOczekiwana wersja: ' + libraryVersion + '. Sprawdź, czy katalog ' +
          'static/scichart/' + libraryVersion + '/ został wgrany na serwer i ' +
          'czy serwer nie przekierowuje tych ścieżek na index.html.'
        )
      }

      return found
    })
}

const WASM_MAGIC = [0x00, 0x61, 0x73, 0x6d] // "\0asm"

function check (url, magic) {
  // Range zamiast pełnego GET – interesują nas tylko nagłówki i magic bytes.
  return fetch(url, { headers: { Range: 'bytes=0-7' } })
    .then(function (response) {
      if (!response.ok && response.status !== 206) {
        return url + ' → HTTP ' + response.status
      }

      const contentType = response.headers.get('content-type') || ''

      // Fallback SPA odpowiada 200 z HTML-em, co Emscripten zgłasza jako błąd
      // instancjonowania modułu.
      if (contentType.indexOf('text/html') !== -1) {
        return url + ' → serwer zwrócił HTML (' + contentType +
          '), prawdopodobnie fallback SPA zamiast pliku'
      }

      if (!magic) {
        return null
      }

      return response.arrayBuffer().then(function (buffer) {
        const bytes = new Uint8Array(buffer)
        const valid = magic.every(function (byte, i) { return bytes[i] === byte })

        return valid ? null : url + ' → to nie jest moduł WebAssembly ' +
          '(nieprawidłowe pierwsze bajty, content-type: ' + contentType + ')'
      })
    })
    .catch(function (error) {
      return url + ' → żądanie nie doszło: ' + error.message
    })
}



// WEBPACK FOOTER //
// ./src/utils/scichartWasm.js